/** Nazvy zvukov */
export enum AudioNames {

  spriteCommentators = 'commentators',
  spriteFootsteps = 'footstepsPlayer',

  audienceCheering = '100m_hyped_overlay',
  audienceIntroNoise = 'audience-noise',
  audienceIntroduction = 'audience-hyped-overlay-5',
  audienceClapping = 'audience-clap-overlay-1',
  audienceFoul = 'audience-bad-overlay-3',
  audienceJavelinOnGround = 'audience-bad-overlay-3',
  audienceJavelinOnGroundBest = 'audience-hyped-overlay-5',
  audienceOutro = 'audience-hyped-overlay-3',

  footstepPlayer = 'footstep-player',
  yellMan = 'yell-man',
  yellWoman = 'yell-woman',

  commentatorIntro = 'intro_01',
  commentatorIntro2 = 'intro_012',
  commentatorBeforeFirstAttempt = 'before_1st_attempt_01',
  commentatorBeforeFirstAttempt2 = 'before_1st_attempt_012',
  commentatorProvisionalStandings = 'after_throw_provisional_standings_01',
  commentatorProvisionalStandings2 = 'after_throw_provisional_standings_012',
  commentatorFinalResults = 'final_results_01',
  commentatorFinalResults2 = 'final_results_012',

  commentatorAfterThrowWR = 'after_throw_world_record',
  commentatorAfterThrowPB = 'after_throw_personal_best_01',
  commentatorAfterThrowPB2 = 'after_throw_personal_best_012',
  commentatorAfterThrow1 = 'after_throw_rank_1_01',
  commentatorAfterThrow1v2 = 'after_throw_rank_1_012',
  commentatorAfterThrow23 = 'after_throw_rank_23_01',
  commentatorAfterThrow23v2 = 'after_throw_rank_23_012',
  commentatorAfterThrow45 = 'after_throw_rank_45_01',
  commentatorAfterThrow45v2 = 'after_throw_rank_45_012',
  commentatorAfterThrow6 = 'after_throw_rank_6_01',
  commentatorAfterThrow6v2 = 'after_throw_rank_6_012',
  commentatorAfterThrowNoImprovementGood = 'after_throw_no_improvement_good_01',
  commentatorAfterThrowNoImprovementGood2 = 'after_throw_no_improvement_good_012',
  commentatorAfterThrowNoImprovementBad = 'after_throw_no_improvement_bad_01',
  commentatorAfterThrowNoImprovementBad2 = 'after_throw_no_improvement_bad_012',
  commentatorAfterThrowFoul = 'after_throw_foul_01',
  commentatorAfterThrowFoul2 = 'after_throw_foul_012',
  commentatorAfterLastThrow1NoImprovement = 'after_last_throw_rank_1_no_improvement',
  commentatorAfterLastThrow1Best = 'after_last_throw_rank_1_best_throw',
  commentatorAfterLastThrow23NoImprovement = 'after_last_throw_rank_23_no_improvement',
  commentatorAfterLastThrow23Best = 'after_last_throw_rank_23_best',
  commentatorAfterLastThrow45 = 'after_last_throw_rank_45',
  commentatorAfterLastThrow6 = 'after_last_throw_rank_6',

}

/** Kategorie zvukov */
export enum AudioCategories {

  start = 'start',
  audience = 'audience',
  character = 'character',
  commentators = 'commentators',
  sprite = 'sprites'

}

/** skupiny zvukov */
export enum AudioGroups {

  commentators = 'commentators',
  audience = 'audience',
  character = 'character',

}
